import $ from 'jquery'

export default {
  getValidationFinalCheck: (state) => {
    return state.validationFinalCheck;
  },

  getRuleByField: (state) => (field) => {
    // return (field);
    // return state.validationRules;
    let rule = {};
    $.each(state.validationRules, (index, value) => {
      if (value.field == field) {
        // console.log(field);
        // console.log(value);
        rule = value.rule;
      }
    });
  //   if(Object.keys(rule).length>0){
  //   console.log(field);
  //   console.log(rule);
  // }
    return rule;
  },

  getValidationFinalResult:(state)=>{
    return state.validationFinalResult;
  },

  // getFormResult: (state ) => (group) => {
  //   console.log(group);
  //   let result = true;
  //   // console.log(state.validationArray[group]);
  //   let resultObj = state.validationArray[group];
  //   for (var key in resultObj){
  //     // skip loop if the property is from prototype
  //     if (!resultObj.hasOwnProperty(key)) continue;
  //     var obj = resultObj[key];
  //     console.log(obj);
  //     result = result && resultObj[key];
  //   }
  //   return result;
  // },

  // getValidationArray:(state ) => (group) => {
  //   console.log(group);
  //   console.log(state.validationArray[group]);
  //   return state.validationArray[group];
  // },



}



// WEBPACK FOOTER //
// ./src/Validation/store/getters.js